import Link from '@/links';
import cx from 'classnames';
import {useTranslations} from 'next-intl';
import type {
  CTAWithOnClickProps,
  GoToAccountCTAProps,
  GoToSettingsCTAProps,
  LogoutCTAProps,
  UserAccountLinksProps
} from '../../types/components/header';
import styles from './header.module.scss';

export const LogInCTA = ({onClickCb}: CTAWithOnClickProps) => {
  const t = useTranslations('shared.header.ctas');
  return (
    <Link
      href="/signin"
      variant="cta-default-no-arrow"
      onClick={onClickCb}
      internal
      customAttributes={{
        'data-gtm': 'header-signin',
        'data-ui': 'header-signin',
        'data-testid': 'login-cta'
      }}
      className={cx(styles['nav-link'], styles['login-cta'])}>
      {t('logIn')}
    </Link>
  );
};

export const RequestDemoCTA = ({onClickCb}: CTAWithOnClickProps) => {
  const t = useTranslations('shared');
  return (
    <Link
      href="/demo"
      variant="primary-sm-no-arrow"
      onClick={onClickCb}
      className={styles['header-action-cta']}
      customAttributes={{
        'data-gtm': 'main-menu-demo',
        'data-ui': 'generic-body-demo',
        'data-testid': 'demo-cta'
      }}>
      {t('demoCTALabel')}
    </Link>
  );
};

export const StartTrialCTA = ({onClickCb}: CTAWithOnClickProps) => {
  const t = useTranslations('shared');
  return (
    <Link
      href="/free-trial"
      variant="secondary-sm-no-arrow"
      onClick={onClickCb}
      className={styles['header-action-cta']}
      customAttributes={{
        'data-gtm': 'main-menu-free-trial',
        'data-ui': 'generic-body-free-trial',
        'data-testid': 'trial-cta'
      }}>
      {t('freeTrialCTALabel')}
    </Link>
  );
};

export const GoToAccountCTA = ({onClickCb, accountName = 'account', href}: GoToAccountCTAProps) => {
  const t = useTranslations('shared.header.ctas');
  return (
    <Link
      href={href}
      variant="cta-default-no-arrow"
      onClick={onClickCb}
      customAttributes={{
        'data-gtm': 'header-go-to-account',
        'data-ui': 'header-go-to-account',
        'data-testid': 'account-cta'
      }}
      className={cx(styles['nav-link'], styles['go-to-account-cta'])}>
      {t('goToAccount', {accountName})}
    </Link>
  );
};

export const GoToSettingsCTA = ({href}: GoToSettingsCTAProps) => {
  const t = useTranslations('shared.header.ctas');
  return (
    <Link
      href={href}
      variant="user-dropdown-inner"
      customAttributes={{
        'data-gtm': 'header-settings',
        'data-ui': 'header-settings',
        'data-testid': 'settings-cta'
      }}
      className={styles['user-dropdown-menu-cta']}>
      {t('settings')}
    </Link>
  );
};

export const LogoutCTA = ({logout}: LogoutCTAProps) => {
  const t = useTranslations('shared.header.ctas');
  return (
    <Link
      href="#"
      onClick={logout}
      variant="user-dropdown-inner"
      customAttributes={{
        'data-gtm': 'header-log-out',
        'data-ui': 'header-log-out',
        'data-testid': 'logout-cta'
      }}
      className={cx(styles['user-dropdown-menu-cta'], styles['user-dropdown-menu-cta-logout'])}>
      {t('logout')}
    </Link>
  );
};

export const UserAccountLinks = ({user, logout}: UserAccountLinksProps) => (
  <ul className={styles['mega-nav-user-dropdown-body']} data-testid="user-account-links">
    <li>
      <GoToSettingsCTA href={user.account.settingsUrl} />
    </li>
    <li>
      <LogoutCTA logout={logout} />
    </li>
  </ul>
);
